// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import {
  showModal as showModalAction,
  hideModal as hideModalAction
} from '../redux/main/actions/modal';

type OwnProps = {
  render: (typeof showModalAction, ?typeof hideModalAction) => React.Node
};

type Props = {
  ...$Exact<OwnProps>,
  showModal: typeof showModalAction,
  hideModal: typeof hideModalAction
};

const ShowModalContainer = ({ render, showModal, hideModal }: Props) =>
  render(showModal, hideModal);

export default connect<Props, OwnProps, _, _, _, _>(
  null,
  { showModal: showModalAction, hideModal: hideModalAction }
)(ShowModalContainer);
